export type DynamicWorkspaceTabActions = DynamicWorkspaceTabSetQuote | DynamicWorkspaceTabUnsetQuote;

export function dynamicWorkspaceTabSetQuote(tabId: string, quoteId: string) {
  return { type: 'DYNAMIC_WORKSPACE_SET_QUOTE' as const, tabId, quoteId };
}
export type DynamicWorkspaceTabSetQuote = ReturnType<typeof dynamicWorkspaceTabSetQuote>;

export function dynamicWorkspaceTabUnsetQuote(tabId: string) {
  return { type: 'DYNAMIC_WORKSPACE_UNSET_QUOTE' as const, tabId };
}
export type DynamicWorkspaceTabUnsetQuote = ReturnType<typeof dynamicWorkspaceTabUnsetQuote>;
